import {config, request, objectSerial} from 'Utils';

export function list(param) {
    return request(`${config.server}/api/v1/dms/shipRequest/list`, {
        method: 'post',
        body: {...param},
    });
}

export function waitreceiptList(param) {
    return request(`${config.server}/api/v1/dms/shipRequest/waitreceiptList`, {
        method: 'post',
        body: {...param},
    });
}

export function requestShip(param) {
    return request(`${config.server}/api/v1/dms/shipRequest/requestShip`, {
        method: 'post',
        body: {...param},
    });
}

export function requestReceipt(param) {
    return request(`${config.server}/api/v1/dms/shipRequest/requestReceipt`, {
        method: 'post',
        body: {...param},
    });
}

export function getRequestShipHistory(param) {
    return request(`${config.server}/api/v1/dms/shipRequest/getRequestShipHistory`, {
        method: 'post',
        body: {...param},
    });
}

export function getHistoryList(param) {
    return request(`${config.server}/api/v1/dms/shipRequest/getHistoryList`, {
        method: 'post',
        body: {...param},
    });
}

export function getBatchPrint(param) {
    return request(`${config.server}/api/v1/dms/shipRequest/getBatchPrint`, {
        method: 'post',
        body: {...param},
    });
}

export function uploadFile(param) {
    return request(`${config.server}/api/v1/dms/shipRequest/uploadFile`, {
        method: 'post',
        body: {...param},
    });
}

export function onhandList(param) {
    return request(`${config.server}/api/v1/dms/shipRequest/onhandList`, {
        method: 'post',
        body: {...param},
    });
}

export function stockScreening(param) {
    return request(`${config.server}/api/v1/dms/tgStock/orgStock`);
}

export function getEscrowCustlist(param) {
    return request(`${config.server}/api/v1/dms/shipRequest/getEscrowCustlist`, {
        method: 'post',
        body: {...param},
    });
}

export function transactionList(param) {
    return request(`${config.server}/api/v1/dms/shipRequest/transactionList`, {
        method: 'post',
        body: {...param},
    });
}

export function escrowDetailList(param) {
    return request(`${config.server}/api/v1/dms/shipRequest/escrowDetailList`, {
        method: 'post',
        body: {...param},
    });
}

export function getEscrowSalesUnitlist(param) {
    return request(`${config.server}/api/v1/dms/shipRequest/getEscrowSalesUnitlist`);
}


// WEBPACK FOOTER //
// ./src/service/shipRequest/index.js